import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31a25982"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "counter__lungs_animated one",
  title: "Breathing Time",
  "data-test": "app-logo"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "two" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "three" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "four" })
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}